"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonAccordion = require("@mmc/common-accordion");

var _commonRichText = require("@mmc/common-rich-text");

var _commonCta = require("@mmc/common-cta");

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _configuratorPackageSelector = _interopRequireDefault(require("../styles/configurator-package-selector.css"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageOptimization = dataUtils.appendImageOptimization;

var renderPanelHeader = function renderPanelHeader(includedOption, i) {
  var textContainer = document.createElement('p');
  textContainer.innerHTML = includedOption.label;
  return /*#__PURE__*/_react["default"].createElement("h3", {
    key: i + "-header"
  }, textContainer.innerText);
};

var renderPanelBody = function renderPanelBody(includedOption, i, theme) {
  var description = handleNestedProp(includedOption, 'includedOption.titleAndText.text');
  var imageSrc = handleNestedProp(includedOption, 'includedOption.image.image');
  var imageWidth = 600;
  var quality = 70;
  var cta = null;

  if (includedOption.link) {
    if (includedOption.link.label && includedOption.link.URL) {
      cta = {
        label: includedOption.link.label,
        url: includedOption.link.URL,
        priority: 'low'
      };
    }
  }

  return /*#__PURE__*/_react["default"].createElement("article", {
    key: i + "-panel",
    className: "" + _configuratorPackageSelector["default"].accordionDetails
  }, imageSrc !== ' ' && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _configuratorPackageSelector["default"].accordionDetailImage,
    src: appendImageOptimization(imageSrc, imageWidth, undefined, undefined, quality),
    alt: handleNestedProp(includedOption, 'includedOption.image.altText')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorPackageSelector["default"].accordionText
  }, description !== ' ' && /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.smallType
  }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
    theme: theme,
    html: description
  })), cta !== null && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    data: cta,
    theme: theme
  })));
};

var renderPanels = function renderPanels(includedOptions, theme) {
  if (includedOptions === void 0) {
    includedOptions = [];
  }

  var includedOptionsMarkup = [];
  includedOptions.forEach(function (includedOption, i) {
    if (includedOption.code !== null) {
      includedOptionsMarkup.push(renderPanelHeader(includedOption, i, theme));
      includedOptionsMarkup.push(renderPanelBody(includedOption, i, theme));
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, includedOptionsMarkup);
};

var AccordionWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(AccordionWrapper, _React$Component);

  function AccordionWrapper() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = AccordionWrapper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        theme = _this$props.theme,
        includedOptions = _this$props.includedOptions;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorPackageSelector["default"].accordion
    }, /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
      theme: theme,
      multiselectable: true,
      children: renderPanels(includedOptions, theme)
    }));
  };

  return AccordionWrapper;
}(_react["default"].Component);

exports["default"] = AccordionWrapper;
AccordionWrapper.displayName = 'AccordionWrapper';
AccordionWrapper.defaultProps = {
  includedOptions: null,
  theme: {}
};